export default function mutations() {
	return {
		setCurrentContract: (state, id) => {
			state.currentContract = id;
		},
		setCurrentPage: (state, page) => {
			state.currentPage = page;
		},
		setSelectedOffer: (state, payload) => {
			state.offer = payload;
			state.insurerCode = payload.insurer_code;
		},
        setPermanentAddress: (state, data) => {
            state.contractingFormData.baseData.permanentAddress = data;
        },
		setFormData: (state, { parent, group, prop, value, index }) => {
			if (!_.has(state.contractingFormData[parent], group)) {
				_.assign(state.contractingFormData[parent], { [group]: {} });
			}

			if (index !== undefined && index !== null) {
				if (!_.has(state.contractingFormData[parent][group], index)) {
					_.assign(state.contractingFormData[parent][group], { [index]: {} });
				}

				if (!_.has(state.contractingFormData[parent][group][index], prop)) {
					_.assign(state.contractingFormData[parent][group][index], { [prop]: null });
				}

				state.contractingFormData[parent][group][index][prop] = value;
			} else {
				if (!_.has(state.contractingFormData[parent][group], prop)) {
					_.assign(state.contractingFormData[parent][group], { [prop]: null });
				}

				state.contractingFormData[parent][group][prop] = value;
			}
		},
		setCheckboxData: (state, { group, insurer, prop, value }) => {
			if (group !== undefined && insurer !== undefined) {
				state.checkboxes[group][insurer][prop] = value;
			} else {
				state.checkboxes[prop] = value;
			}
		},
		setOfferResponse: (state, payload) => {
			state.offerResponse = payload;
		},
		setBrokerageData: (state, payload) => {
			state.brokerageData = payload;
		},
		deleteBenediciaryData: (state, index) => {
			if (state.contractingFormData.baseData.beneficiaryData !== undefined) {
				if (state.contractingFormData.baseData.beneficiaryData[index] !== undefined) {
					delete state.contractingFormData.baseData.beneficiaryData[index];
				}
			}
		},
		deleteInsuredsData: (state, index) => {
			if (state.contractingFormData.baseData.insuredsData !== undefined) {
				if (state.contractingFormData.baseData.insuredsData[index] !== undefined) {
					delete state.contractingFormData.baseData.insuredsData[index];
				}
			}
		},
		deleteInsuredsInsuredData: (state, index) => {
			if (state.contractingFormData.insuredData.insuredsData !== undefined) {
				if (state.contractingFormData.insuredData.insuredsData[index] !== undefined) {
					delete state.contractingFormData.insuredData.insuredsData[index];
				}
			}
		},
		setFinancers: (state, payload) => {
			state.financers = payload;
		},
		setBanks: (state, payload) => {
			state.banks = payload;
		},
		setWsErrors: (state, payload) => {
			state.wsErrors = payload;
		},
		setDamageEvent: (state, payload) => {
			state.damageEvent = payload;
		},
		setValueByProp: (state, { prop, payload }) => {
			state[prop] = payload;
		},
		refreshContractData: state => {
			state.contractingFormData = {
				baseData: {},
				insuredData: {},
				financingData: {},
			};
		},
		setDisabledInput: (state, input) => {
			state.disabledInputs.push(input);
		},
		setInited: (state, payload) => {
			state.inited = payload;
		},
        setContractSummary: (state, payload) => {
            state.summary = payload;
        },
        setNewContractType: (state, payload) => {
            state.brokerageData.newType =  payload;
        },
	};
}
